import { render } from "./AppProfile.vue?vue&type=template&id=009d3f28"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"
script.render = render

export default script